export default __webpack_public_path__ + "static/media/beer-mug.b2439523.png";